
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { UserProvider } from "@/contexts/UserContext";
import Index from "./pages/Index";
import PsychologistDirectory from "./pages/PsychologistDirectory";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import PatientDashboard from "./pages/PatientDashboard";
import PsychologistProfile from "./pages/PsychologistProfile";
import PsychologistDashboard from "./components/psychologist/PsychologistDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ScheduleStep1 from "./pages/ScheduleStep1";
import ScheduleStep2 from "./pages/ScheduleStep2";
import ScheduleStep3 from "./pages/ScheduleStep3";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailure from "./pages/PaymentFailure";
import PaymentPending from "./pages/PaymentPending";
import VideoCallPage from "./pages/VideoCallPage";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navbar from "./components/layout/Navbar";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <HelmetProvider>
          <Toaster />
          <BrowserRouter>
            <LanguageProvider>
              <AuthProvider>
                <UserProvider>
                  <div className="min-h-screen bg-background">
                    <Navbar />
                    <main className="container mx-auto px-4 py-8">
                      <Routes>
                        <Route path="/" element={<Index />} />
                        <Route path="/psychologists" element={<PsychologistDirectory />} />
                        <Route path="/psychologist/:id" element={<PsychologistProfile />} />
                        <Route path="/login" element={<Auth />} />
                        <Route path="/register" element={<Auth />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/patient-dashboard" element={<PatientDashboard />} />
                        <Route path="/psychologist-dashboard" element={<PsychologistDashboard />} />
                        <Route path="/admin-dashboard" element={<AdminDashboard />} />
                        <Route path="/schedule" element={<ScheduleStep1 />} />
                        <Route path="/schedule/step1" element={<ScheduleStep1 />} />
                        <Route path="/schedule/step2" element={<ScheduleStep2 />} />
                        <Route path="/schedule/step3" element={<ScheduleStep3 />} />
                        <Route path="/appointment/success/:appointmentId" element={<PaymentSuccess />} />
                        <Route path="/appointment/failure" element={<PaymentFailure />} />
                        <Route path="/appointment/pending" element={<PaymentPending />} />
                        <Route path="/appointment/videocall/:appointmentId" element={<VideoCallPage />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/failure" element={<PaymentFailure />} />
                        <Route path="/payment/pending" element={<PaymentPending />} />
                      </Routes>
                    </main>
                  </div>
                </UserProvider>
              </AuthProvider>
            </LanguageProvider>
          </BrowserRouter>
        </HelmetProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
